var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',[_c('datatable',{attrs:{"header":_vm.headers,"item":_vm.desserts,"showAction":true,"showSearch":true}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title pageheading",staticStyle:{"height":"50px"}},[_c('h3',{staticClass:"titlename"},[_c('i',{staticClass:"fas fa-user"}),_c('span',{staticClass:"ml-3"},[_vm._v("Care Coordinator Dashboard")])])])
}]

export { render, staticRenderFns }